module.exports = {"152523100":"满都拉图镇","152523101":"查干敖包镇","152523102":"巴彦淖尔镇","152523200":"巴彦乌拉苏木","152523201":"赛罕高毕苏木","152523202":"洪格尔苏木","152523203":"达来苏木","152523400":"苏尼特左旗芒来循环经济产业园区","152523500":"恩格尔河灌区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152523.json
// module id = 440
// module chunks = 0